import { createTheme } from "@mui/material/styles";

const customFontSizes = {
    fontSize64: "4em",
    fontSize32: "2em",
    fontSize36: "2.25em",
    fontSize28: "1.75em",
    fontSize24: "1.5em",
    fontSize20: "1.25em",
    fontSize16: "1em",
    fontSize14: "0.875em",
    fontSize12: "0.75em",
    fontSize10: "0.625em",
}

const customThemeColors = {
    disabledButton: "#808080",
    voteColor: "#2CBD00",
    blueThemeColor: "#0024FF",
    disabledBlueThemeColor: "#001152",
    redThemeColor: "#FF1400",
    disabledRedThemeColor: "#C04A40",
    smallScreenArtistBgColor: "#3D31DF",
    
}

export const lightMode = createTheme({
    palette: {
        ...customFontSizes,
        ...customThemeColors,
        primary: {
            main: "#FFFFFF",
        },
        error: {
            main: "#F00",
        },
        secondary: {
            main: "#0025FF",
        },
        success: {
            main: "#2CBD00"
        }
    },
    typography: {
        allVariants: {
            color: "#FFFFFF",
            fontFamily: "Inter"
        },
    },
    components: {
        MuiLinearProgress: {
            styleOverrides: {
                root: {
                    height: 10,
                    '&.MuiLinearProgress-determinate': {
                        backgroundColor: '#00000080',
                    },

                }
            }
        },
        MuiInput: {
            styleOverrides: {
                root: {
                    color: "#FFFFFF",
                    borderColor: "#FFFFFF",
                    '::before': {
                        borderBottomColor: '#FFFFFF'
                    }
                }
            }
        },
    },
});